import {Link, useLocation, useParams} from 'react-router-dom'
import {KTIcon} from '../../../../_metronic/helpers'
import {useQuery} from 'react-query'
import toast from 'react-hot-toast'
import axios from 'axios'
import {BASE_URL} from '../../config'
import {formatDateAsDayAndTime} from './../../../utils/helperFunction/_helper'
import CardSkeleton from '../../../utils/components/Skeleton/CardSkeleton'
import {PartialArticleWithDate} from '../core/_model'

const GET_CATEGORY_BY_ID = `${BASE_URL}/api/protect/getKnoledgeByCategory`

const ArticlesByCategory = () => {
  const {id} = useParams()
  const {state} = useLocation()

  console.log(state)

  const {
    data: articles,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['article'],
    queryFn: async () => {
      const response = await axios.get<PartialArticleWithDate[]>(`${GET_CATEGORY_BY_ID}/${id}`)
      const data = await response.data

      console.log(data)

      return data
    },
    onError: (error: Error) => {
      console.log(error)
      toast.error('Unexpected error! Try again!')
    },
    onSuccess: () => {
      toast.dismiss()
    },
    enabled: !!id,
  })

  return (
    <div className=''>
      {isLoading && !articles ? (
        <div className='text-center'>
          <p className='fs-5 fw-bold text-gray-800 mb-4'>Processing {state?.categoryName} Data..</p>
          {/* <div className='d-flex justify-content-center mb-8'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div> */}
          <CardSkeleton />
          <CardSkeleton />
        </div>
      ) : (
        <>
          {articles && articles.length > 0 ? (
            <>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold text-dark'>Articles / </span>
                <span className='text-gray-700 mt-1 fw-semibold fs-2'>{state?.categoryName}</span>
              </h3>

              <div className='mt-8'>
                {articles.map((article) => (
                  <div className='card mb-4' key={article?.id}>
                    <div className='card-body'>
                      <div className='d-flex align-items-center'>
                        {/* begin::Symbol */}
                        <div className='symbol symbol-40px me-5'>
                          <span className='symbol-label bg-light-success'>
                            <KTIcon iconName='abstract-26' className='fs-2 text-success' />
                          </span>
                        </div>
                        {/* end::Symbol */}
                        {/* begin::Text */}
                        <div className='d-flex flex-column'>
                          <Link
                            to={`/knowledgebase/article-view/${article.id}`}
                            className='text-dark text-hover-primary fs-6 fw-bold'
                          >
                            {article?.title}
                          </Link>
                          <span className='text-muted fw-semibold'>
                            Created: {formatDateAsDayAndTime(article.created_at)}
                          </span>
                        </div>
                        {/* end::Text */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <div className='text-center'>
                <p className='fs-5 fw-bold text-gray-800'>
                  No data available for {state?.categoryName}
                </p>
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default ArticlesByCategory
